import { Component, OnInit, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-other-insurance-claim-details',
  templateUrl: './other-insurance-claim-details.component.html',
  styleUrls: ['./other-insurance-claim-details.component.scss'],
})
export class OtherInsuranceClaimDetailsComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  notesIcon = this.RESOURCE_SERVER_URL + '/assets/images/menu_book.svg';
  addIcon = this.RESOURCE_SERVER_URL + '/assets/images/addPurple.svg';
  editIcon = this.RESOURCE_SERVER_URL + '/assets/images/Edit.svg';
  deleteIcon =
    this.RESOURCE_SERVER_URL +
    '/assets/images/Underwriting_new/Underwriting/Requirements/Delete.svg';

  addCircleIcon = this.RESOURCE_SERVER_URL + '/assets/images/add.svg';
  claimId: any;
  isLoading: boolean = false;
  commonToggleList = [
    {
      label: 'label.common.yes',
      value: 'Y',
    },
    {
      label: 'label.common.no',
      value: 'N',
    },
  ];
  lastPolicyNumber = 51002933;
  //otherInsuranceClaimsList = [{ policyNo: this.lastPolicyNumber.toString() }];
  otherInsuranceClaimsList;
  selecteToggle: string = 'N';
  claimsUrl: any;

  constructor(
    private commonService: CommonService,
    private dialogRef: MatDialogRef<OtherInsuranceClaimDetailsComponent>,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  async ngOnInit(): Promise<void> {
    this.isLoading = true;
    this.claimId = this.data.claimID;
    this.claimsUrl = this.data.claimUrl;
    await this.getAllOtherInsurance();
  }

  async getAllOtherInsurance() {
    try {
      let url =
        this.claimsUrl +
        '/person/' +
        localStorage.getItem('personUuidInsurance') +
        '/otherInsurance';
      let getAllInsuranceResponse = await this.commonService.commonGet(url);
      this.otherInsuranceClaimsList = getAllInsuranceResponse.body._links.item;
      this.isLoading = false;
    } catch (error) {
      console.log('Get All OtherInsurance Failed', error);
      this.isLoading = false;
    }
  }

  async onCloseDialog() {
    this.dialogRef.close();
  }
  addRow() {
    this.lastPolicyNumber++;
    this.otherInsuranceClaimsList.push({
      policyNo: this.lastPolicyNumber.toString(),
    });
  }
  deleteRow(index: number) {
    this.otherInsuranceClaimsList.splice(index, 1);
  }
}
